import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "space-y-1" }

import ColoredText from '@/components/ColoredText.vue';
import DefaultChip from '../components/DefaultChip.vue';

import { useCalculatorEstimated } from '../composables/useCalculatorEstimated';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationStepperSummary',
  setup(__props) {

const { calculationRules } = useCalculatorEstimated();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "font-bold text-gray-900" }, "Podsumowanie kalkulacji", -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(calculationRules), (rule) => {
      return (_openBlock(), _createElementBlock("div", {
        key: rule.id,
        class: "flex items-center justify-between gap-4 py-3.5 text-sm font-medium text-gray-iron-700"
      }, [
        _createVNode(ColoredText, {
          variant: rule.color
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(rule.name), 1)
          ]),
          _: 2
        }, 1032, ["variant"]),
        _createVNode(DefaultChip, {
          variant: rule.color
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(rule.eval) + " " + _toDisplayString(rule.unit), 1)
          ]),
          _: 2
        }, 1032, ["variant"])
      ]))
    }), 128))
  ]))
}
}

})